import { Injectable } from '@angular/core';
import { TranslocoFallbackStrategy } from '@jsverse/transloco';
@Injectable({
  providedIn: 'root',
})
export class LanguageFallbackStrategyService
  implements TranslocoFallbackStrategy
{
  getFallbacks(language: string): string[] {
    return this.getNextLangs(language);
  }

  getNextLangs(language: string): string[] {
    switch (language) {
      case 'pt-BR':
        return ['pt-PT', 'en'];
      case 'pt-PT':
        return ['pt-BR', 'en'];
      case 'fr-CA':
        return ['fr-FR', 'en'];
      case 'fr-FR':
        return ['fr-CA', 'en'];
      case 'it':
        return ['en'];
      case 'de':
        return ['en'];
      case 'es':
        return ['es-MX', 'en'];
      case 'es-MX':
        return ['es', 'en'];
      default:
        return ['en'];
    }
  }
}
